module.exports = __webpack_public_path__ + "img/calendar2.92c3c4b8.svg";